import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
// 引入翻譯相關
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { I18nService } from '../../../services/i18n.service';

// import { EnvironmentService } from '../../../services/enviroment.service';
// import { environment } from '../../../services/global-environment';;
import { environment } from '../../../services/global-environment';

import { DatabaseService } from '../../../services/database.service';
import { LogService } from '../../../services/Logging.service';
import { SdsParserComponent } from '../sds-parser/sds-parser.component';
import { AzureBlobService } from '../../../services/azure-blob.service';
import { ChemicalRegulationComponent } from '../chemical-regulation/chemical-regulation.component';
// import chemicalMapping from '../../../../assets/data/chemical_mapping.json';

interface SdsItem {
  id: string;
  chineseName: string;
  englishName: string;
  partNumber: string;
  componentCount: number;
  fileurl: string;
  filename: string; // 新增
  sds_details?: any; // 這裡可以根據實際情況調整型別
  departments: string[];
  completeness: number;
  lastUpdated: string;
  versionDate: string; // 添加 SDS 版本日期欄位
  regulation_details?: any; // 新增，對應法規判定資料

}

// 擴充 SdsItem 型別，讓 mock 欄位在 template 可用
interface SdsItemWithMock extends SdsItem {
  mockDepartmentCount: number;
  mockRegulationCount: number;
  mockAreaCount: number;
}

@Component({
  selector: 'app-sds-list',
  templateUrl: './sds-list.component.html',
  styleUrls: ['./sds-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    SdsParserComponent,
    ChemicalRegulationComponent
  ]
})
export class SdsListComponent implements OnInit {
  // 注入 i18n 服務
  private i18nService = inject(I18nService);

  sdsItems: SdsItem[] = [];
  filteredItems: SdsItem[] = []; // 這裡型別要改
  loading: boolean = true;
  searchTerm: string = '';
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalPages: number = 1;

  private apiUrl = environment.apiUrl;
  private companyId = environment.companyid;

  // 添加到類成員部分
showAddModal: boolean = false;
newSdsItem: any = this.getEmptySdsItem();
selectedFile: File | null = null;
selectedDepartments: {[key: string]: boolean} = {};
availableDepartments: string[] = ['研發部', '品管部', '生產部', '實驗室', '維修部', '行政部', '倉儲部', '安衛部'];
fileUploading: boolean = false;
errorMessage: string = '';

showAutoParseDialog = false;
selectedSdsItem: any = null;
selectedSdSurl: string ="";
selectedSdSname: string = "";


uploadFiles: File[] = [];
uploadError: string = '';
uploading: boolean = false;
isDragOver: boolean = false;

showSdsDetailsDialog = false;
selectedSdsDetailsItem: any = null;
selectedSdsDetailsViewModel: boolean = false;

// 解析進度狀態
parsingStatus: { [id: string]: { loading: boolean, percent: number } } = {};

// 列管法規自動判定彈窗狀態
showRegulationDialog: boolean = false;
selectedRegulationMaterials: any[] = [];

// 成分詳細資訊彈窗狀態
showComponentDetailsDialog: boolean = false;
// 法規明細彈窗狀態
  showRegulationDetailsDialog: boolean = false;
  selectedRegulationDetailsItem: any = null;

// chemical id to name map
  chemicalIdNameMap: { [id: string]: string } = {};


selectedComponentItem: any = null;

// 法規判定操作中的 item
selectedRegulationItem: any = null;
// 處理 chemical-regulation 子元件的 saveRegulations 事件


  constructor(
    private http: HttpClient,
    private databaseService: DatabaseService,
    private logService: LogService,
    private azureBlobService: AzureBlobService // <--- 新增這一行
  ) {}

  ngOnInit(): void {
    // 監聽語言變更，可能需要重新處理某些依賴語言的數據
    this.i18nService.currentLang.subscribe(() => {
      // 如果有一些顯示需要根據語言變化而變化的邏輯，可以放在這裡
      // 例如：重新格式化日期、重新排序等
    });

    // 載入 chemical_mapping.json 並建立 id→name map
    this.http.get<any[]>('assets/data/chemical_mapping.json').subscribe({
      next: (data) => {
        if (Array.isArray(data)) {
          data.forEach(item => {
            if (item.id && item.name) {
              this.chemicalIdNameMap[item.id] = item.name;
            }
          });
        }
      },
      error: (err) => {
        console.error('載入 chemical_mapping.json 失敗', err);
      }
    });
    this.loadSdsItems();
  }


  openRegulationDetailsDialog(item: any) {

    this.selectedRegulationDetailsItem = item;
    this.showRegulationDetailsDialog = true;
  }

  closeRegulationDetailsDialog() {
    this.showRegulationDetailsDialog = false;
    this.selectedRegulationDetailsItem = null;
  }

  onSaveRegulations(event: any[]) {
  // 設定 regulation_details
  if (this.selectedRegulationItem) {
    this.selectedRegulationItem.regulation_details = {
      updatedate: new Date().toISOString().slice(0, 10),
      regulation_result: event
    };

    // 呼叫 API 更新 regulation_details
    const updateBody = {
      id: this.selectedRegulationItem.id,
      companyid: this.companyId,
      regulation_details: this.selectedRegulationItem.regulation_details
    };

    this.http.put(`${this.apiUrl}/api/chemicals/updateregulation`, updateBody)
      .subscribe({
        next: (res) => {
          // 可選: 處理成功回應
          console.log('Regulation details updated:', res);
        },
        error: (err) => {
          // 可選: 處理錯誤
          console.error('Failed to update regulation details:', err);
        }
      });
  }
  // 關閉法規 modal
  this.showRegulationDialog = false;
  // 你可以在這裡處理子元件 emit 上來的資料
}


  // 將 id 陣列轉成 name 字串
  getRegulationNames(ids: string[]): string {
    if (!Array.isArray(ids)) return '';
    return ids
      .map((id, idx) => `${idx + 1}. ${this.chemicalIdNameMap[id] || id}`)
      .join('\n');
  }

  loadSdsItems(): void {
    this.loading = true;
    this.sdsItems = [];
    this.filteredItems = [];

    this.http.get<any[]>(`${this.apiUrl}/api/chemicals/sds?companyid=${this.companyId}`).subscribe({
      next: (items) => {


        console.log('API 回傳的資料:', items);

        // 將 API 回傳的資料轉換成 SdsItem[]
        this.sdsItems = (items || []).map((item: any) => {

          // 從 sds_details 取出中文/英文名稱、料號等
          const details = item.sds_details?.item1 || {};

        const CreateDate = item.sds_details?.item0?.CreateDate || '';

          return {
            id: item.sds_id || item.id || '', // 以 sds_id 為主
            chineseName: details.ChemicalZhName || item.filename ,
            englishName: details.ChemicalEnName || '',
            partNumber: item.partNumber || '',
            componentCount: Array.isArray(item.sds_details?.item3?.materials) ? item.sds_details.item3.materials.length : 0,
            fileurl: item.fileurl || '',
            filename: item.filename || '', // 新增
            sds_details: item.sds_details || {},
            departments: item.departments || [],
            completeness: item.completeness ?? 0,
            lastUpdated: item.uploadedAt ? item.uploadedAt.split('T')[0] : '',
            versionDate: CreateDate,
            regulation_details: item.regulation_details || null // 補上法規判定資料
          } as SdsItem;
        });
        this.applyFilters();
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading SDS data:', error);
        this.sdsItems = [];
        this.filteredItems = [];
        this.loading = false;
      }
    });
  }


  applyFilters(): void {
    let result = [...this.sdsItems];

    console.log('原始資料:', result);

    // 搜尋過濾
    if (this.searchTerm) {
      const searchLower = this.searchTerm.toLowerCase();
      result = result.filter(item =>
        item.chineseName.toLowerCase().includes(searchLower) ||
        item.englishName.toLowerCase().includes(searchLower) ||
        item.partNumber.toLowerCase().includes(searchLower) ||
        item.departments.some(dept => dept.toLowerCase().includes(searchLower))
      );
    }

    // 排序
    if (this.sortColumn) {
      result.sort((a, b) => {
        const valueA = a[this.sortColumn as keyof SdsItem];
        const valueB = b[this.sortColumn as keyof SdsItem];

        if (typeof valueA === 'string' && typeof valueB === 'string') {
          return this.sortDirection === 'asc'
            ? valueA.localeCompare(valueB)
            : valueB.localeCompare(valueA);
        } else {
          // 數值比較
          return this.sortDirection === 'asc'
            ? (valueA as number) - (valueB as number)
            : (valueB as number) - (valueA as number);
        }
      });
    }

    // 計算總頁數
    this.totalPages = Math.ceil(result.length / this.itemsPerPage);

    // 分頁
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.filteredItems = result.slice(startIndex, endIndex).map(item => ({
      ...item
    }));
  }

  search(): void {
    this.currentPage = 1;
    this.applyFilters();
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.search();
  }

  sort(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.applyFilters();
  }

  getSortIcon(column: string): string {
    if (this.sortColumn !== column) return 'fa fa-sort';
    return this.sortDirection === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down';
  }

  changePage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.applyFilters();
  }

  viewSdsFile(fileurl: string): void {
  if (fileurl) {
    window.open(fileurl, '_blank');
  }
}
  getCompletenessClass(completeness: number): string {
    if (completeness >= 90) return 'high';
    if (completeness >= 70) return 'medium';
    return 'low';
  }

  // 生成頁碼陣列供分頁器使用
  get pageNumbers(): number[] {
    const pages = [];
    const maxButtons = 5; // 最多顯示的分頁按鈕數

    if (this.totalPages <= maxButtons) {
      // 如果總頁數小於等於最大按鈕數，顯示所有頁碼
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
    } else {
      // 顯示部分頁碼，並在中間顯示當前頁
      const halfButtons = Math.floor(maxButtons / 2);
      let startPage = Math.max(1, this.currentPage - halfButtons);
      let endPage = Math.min(this.totalPages, startPage + maxButtons - 1);

      // 調整起始頁和結束頁，確保總是顯示 maxButtons 個按鈕
      if (endPage - startPage + 1 < maxButtons) {
        startPage = Math.max(1, endPage - maxButtons + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  }

// 獲取空白的SDS項目模板
getEmptySdsItem(): any {
  return {
    chineseName: '',
    englishName: '',
    partNumber: '',
    componentCount: 0,
    sdsFile: '',
    departments: [],
    completeness: 0,
    versionDate: this.formatDateForInput(new Date())
  };
}

// 打開新增SDS模態框
openAddModal(): void {
  this.showAddModal = true;
  this.newSdsItem = this.getEmptySdsItem();
  this.selectedFile = null;
  this.selectedDepartments = {};
  this.errorMessage = '';
}

// 關閉新增SDS模態框
closeAddModal(): void {
  this.showAddModal = false;
}

// 處理檔案選擇
onFileSelected(event: Event): void {
  const element = event.target as HTMLInputElement;
  const files = element.files;

  if (files && files.length > 0) {
    this.selectedFile = files[0];

    // 從檔名中自動提取部分資訊
    const fileName = this.selectedFile.name;
    if (fileName.toLowerCase().endsWith('.pdf')) {
      // 假設檔案名稱格式為: 化學品名稱_部件號.pdf
      const nameParts = fileName.split('_');
      if (nameParts.length > 0 && !this.newSdsItem.chineseName) {
        this.newSdsItem.chineseName = nameParts[0];
      }

      // 設定檔案名稱
      this.newSdsItem.sdsFile = fileName;
    } else {
      this.errorMessage = '請上傳PDF格式的SDS檔案';
      this.selectedFile = null;
    }
  }
}

// 切換部門選擇
toggleDepartment(dept: string): void {
  this.selectedDepartments[dept] = !this.selectedDepartments[dept];
}


// 格式化日期為輸入框格式 (YYYY-MM-DD)
formatDateForInput(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// 打開自動解析模態框
openAutoParseDialog(item: any) {


  console.log('開啟自動解析對話框，選擇的 SDS 項目:', item);


  // 初始化進度
  this.parsingStatus[item.id] = { loading: true, percent: 0 };

  const formData = new FormData();
  formData.append('companyid', this.companyId);
  formData.append('targetlist', '-1');
  if (item.fileurl) formData.append('fileurl', item.fileurl);

  const url = `${this.apiUrl}/api/sdsparser`;


  fetch(url, {
    method: 'POST',
    body: formData,
    headers: { Accept: 'text/event-stream' }
  }).then(response => {
    if (!response.ok || !response.body) throw new Error('Network error');
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let resultJson = '';
    let finishedCount = 0;
    const totalSections = 17;

    const processChunk = (chunk: string) => {
      // 只要 chunk 包含 result: {"model": 就處理
      if (chunk.includes('result: {"model":')) {
        let jsonStr = chunk.replace('result: ', '').replace('event: end', '').trim();
        try {
          const json = JSON.parse(jsonStr);

          console.log('解析結果:', json);

          // 1. 先更新 this.sdsItems 中對應 id 的 item
          const idx = this.sdsItems.findIndex((i) => i.id === item.id);

          // 取出 item1 欄位
          const item0 = json.model?.item0 || {};
          const item1 = json.model?.item1 || {};

          const chineseName = item1.ChemicalZhName ;
          const englishName = item1.ChemicalEnName || '';
          const versionDate = item0.CreateDate || '';

          // 計算成分數
          let componentCount = 0;
          if (json.model && json.model.item3 && Array.isArray(json.model.item3.materials)) {
            componentCount = json.model.item3.materials.length;
          }

          // 計算完整度
          const completeness = this.calculateCompleteness({
            ...item,
            sds_details: json.model,
            componentCount: componentCount,
            chineseName,
            englishName,
            versionDate
          });

          // 2. 同步更新 this.sdsItems 與傳進來的 item
          if (idx !== -1) {
            this.sdsItems[idx].sds_details = json.model;
            this.sdsItems[idx].completeness = completeness;
            this.sdsItems[idx].componentCount = componentCount;
            this.sdsItems[idx].chineseName = chineseName;
            this.sdsItems[idx].englishName = englishName;
            this.sdsItems[idx].versionDate = versionDate;
          }
          item.sds_details = json.model;
          item.completeness = completeness;
          item.componentCount = componentCount;
          item.chineseName = chineseName;
          item.englishName = englishName;
          item.versionDate = versionDate;

          console.log('SDS 詳細資料:', item.sds_details);

        // 3. 更新 SDS 回資料庫
        try {
          const updateBody = {
            ...item,
            companyid: this.companyId,
            id:item.id
          };
          fetch(`${this.apiUrl}/api/chemicals/updatesds`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(updateBody)
          })
          .then(res => res.json())
          .then(res => {
            console.log('SDS 已更新至資料庫:', res);
          })
          .catch(err => {
            console.error('SDS 更新資料庫失敗:', err);
          });
        } catch (err) {
          console.error('SDS 更新資料庫時發生例外:', err);
        }
        } catch (e) {
          // 同步清空
          const idx = this.sdsItems.findIndex((i) => i.id === item.id);
          if (idx !== -1) {
            this.sdsItems[idx].sds_details = {};
          }
          item.sds_details = {};
        }
      }
    };

    const readChunk = () => {
      reader.read().then(({ done, value }) => {
        if (done) {
          this.parsingStatus[item.id].loading = false;
          this.applyFilters();
          return;
        }
        const chunk = decoder.decode(value, { stream: true });
        // 統計進度
        const matchArr = chunk.match(/\[S(\d+)\]\s*Done/g);
        if (matchArr) {
          finishedCount += matchArr.length;
          this.parsingStatus[item.id].percent = Math.round((finishedCount / totalSections) * 100);
        }
        // 處理 JSON 結果
        processChunk(chunk);
        readChunk();
      }).catch(() => {
        this.parsingStatus[item.id].loading = false;
      });
    };
    readChunk();
  }).catch(() => {
    this.parsingStatus[item.id].loading = false;
  });
}

closeAutoParseDialog() {
  this.showAutoParseDialog = false;
  this.selectedSdsItem = null;
}

// 自動解析儲存
onAutoParseSave(parseResult: any) {
  // 可根據 parseResult 更新列表資料
  this.closeAutoParseDialog();
  // 例如自動解析完成後設為100%
  if (this.selectedSdsItem) {
    this.selectedSdsItem.completeness = 100;
  }
}

onFileDrop(event: DragEvent) {
  event.preventDefault();
  this.isDragOver = false;
  if (event.dataTransfer?.files) {
    this.addUploadFiles(event.dataTransfer.files);
  }
}

onDragOver(event: DragEvent) {
  event.preventDefault();
  this.isDragOver = true;
}

onDragLeave(event: DragEvent) {
  event.preventDefault();
  this.isDragOver = false;
}

onFileSelect(event: Event) {
  const input = event.target as HTMLInputElement;
  if (input.files) {
    this.addUploadFiles(input.files);
    input.value = '';
  }
}

addUploadFiles(fileList: FileList) {
  this.uploadError = '';
  for (let i = 0; i < fileList.length; i++) {
    const file = fileList[i];
    if (file.type !== 'application/pdf') {
      this.uploadError = '僅支援 PDF 檔案';
      continue;
    }
    if (!this.uploadFiles.some(f => f.name === file.name && f.size === file.size)) {
      this.uploadFiles.push(file);
    }
  }
}

removeFile(index: number) {
  this.uploadFiles.splice(index, 1);
}

async uploadSdsFiles() {
  if (this.uploadFiles.length === 0) return;
  this.uploading = true;
  this.uploadError = '';
  try {
    for (const file of this.uploadFiles) {
      // 1. 上傳到 Azure Blob Storage
      // 假設 azureBlobService.uploadFile 回傳檔案URL
      const fileUrl = await this.azureBlobService.uploadFile(
        file,
        this.companyId,
        'sds'
      );

      // 2. 寫入 Cosmos DB
      const fileMeta = {
        companyid: this.companyId,
        fileurl: fileUrl,
        filename: file.name,
        completeness :10, //有檔案名稱跟Url就給10分
        uploadedAt: new Date().toISOString()
      };
      await this.databaseService.sendDataToBackend(fileMeta, 'chem_SDS');
    }
    // 上傳成功後清空
    this.uploadFiles = [];
    this.closeAddModal();
    // 可選: 重新載入列表
    this.loadSdsItems();
  } catch (err: any) {
    this.uploadError = err?.message || '上傳失敗';
  }
  this.uploading = false;
}

openSdsDetailsDialog(item: any) {
  this.selectedSdsDetailsItem = item;
  this.selectedSdsDetailsViewModel = true;
  this.showSdsDetailsDialog = true;
}

closeSdsDetailsDialog() {
  this.showSdsDetailsDialog = false;
  this.selectedSdsDetailsItem = null;
  this.selectedSdsDetailsViewModel = false;
}

// 加在 class SdsListComponent 內部
objectKeys(obj: any): string[] {
  return obj ? Object.keys(obj) : [];
}
// 計算 SDS 完整度
private calculateCompleteness(sdsItem: SdsItem): number {
  let completeness = 100;
  const details = sdsItem.sds_details || {};

  // 1. item1 ~ item16
  for (let i = 1; i <= 16; i++) {
    const key = `item${i}`;
    const section = details[key];
    // 若不存在或所有值都是空
    if (
      !section ||
      (typeof section === 'object' &&
        Object.values(section).every(
          v => v === '' || v === null || v === undefined
        ))
    ) {
      completeness -= 5;

    }
  }

  // 2. chineseName 為空
  if (!sdsItem.chineseName || sdsItem.chineseName.trim() === '') {
    completeness -= 5;
  }
  // 3. fileurl 為空
  if (!sdsItem.fileurl || sdsItem.fileurl.trim() === '') {
    completeness -= 5;
  }
  // 4. versionDate 為空
  if (!sdsItem.versionDate || sdsItem.versionDate.trim() === '') {
    completeness -= 5;
  }

  // 不低於 0
  return Math.max(0, completeness);
}
  // 開啟成分詳細資訊彈窗
  openComponentDetailsDialog(item: any) {
    this.selectedComponentItem = item;
    this.showComponentDetailsDialog = true;
  }

  // 關閉成分詳細資訊彈窗
  closeComponentDetailsDialog() {
    this.showComponentDetailsDialog = false;
    this.selectedComponentItem = null;

  }

  // 開啟列管法規自動判定彈窗
      openRegulationDialog(item: any) {
this.selectedRegulationItem = item;
        // 取出成分陣列，若無則給空陣列
        this.selectedRegulationMaterials = (item?.sds_details?.item3?.materials || []).map((mat: any) => ({
          chineseName: mat.ChineseName || mat.MaterialName || mat.ChemicalZhName || mat.name || '',
          englishName: mat.EnglishName || mat.ChemicalEnName || mat.enName || '',
          casNo: mat.CasNo || mat.CASNo || mat.casNo || '',
          percentage: mat.Percentage || mat.Content || mat.content || ''
        }));
        // 至少要有一個空白成分
        if (this.selectedRegulationMaterials.length === 0) {
          this.selectedRegulationMaterials = [{ chineseName: '', englishName: '', casNo: '', percentage: '' }];
        }
        this.showRegulationDialog = true;
      }

      // 關閉列管法規自動判定彈窗
      closeRegulationDialog() {
        this.showRegulationDialog = false;
        this.selectedRegulationMaterials = [];
      }

}
